<template>
  <div>
    <base-header type="gradient-warning" class="pb-6 pb-8 pt-5 pt-md-8">
      <!-- Card stats -->
      <div class="row">
        <div class="col-lg-4 d-flex align-items-stretch">
          <stats-card
            title="Total de tarefas"
            type="gradient-orange"
            :sub-title="String(stats.totalTasks)"
            icon="ni ni-chart-pie-35"
            class="mb-4 mb-xl-0 flex-grow-1"
          >
            <template slot="footer">
              <span class="text-wrap"
                >das quais {{ stats.totalAvailableTasks }} já iniciaram</span
              >
            </template>
          </stats-card>
        </div>
        <div class="col-lg-4 d-flex align-items-stretch">
          <stats-card
            title="Total de respostas"
            type="gradient-red"
            :sub-title="String(stats.totalResponses)"
            icon="ni ni-active-40"
            class="mb-4 mb-xl-0 flex-grow-1"
          >
            <template slot="footer">
              <span class="text-wrap">entre as startups do batch</span>
            </template>
          </stats-card>
        </div>
        <div class="col-lg-4 d-flex align-items-stretch">
          <stats-card
            title="Média de respostas"
            type="gradient-info"
            :sub-title="String(stats.percentAnsweredTasks)"
            icon="ni ni-chart-bar-32"
            class="mb-4 mb-xl-0 flex-grow-1"
          >
            <template slot="footer">
              <span class="text-wrap">
                respostas &#247; (tarefas iniciadas &#xd7; startups)
              </span>
            </template>
          </stats-card>
        </div>
      </div>
    </base-header>

    <div class="container-fluid mt--7">
      <div class="row">
        <div class="col">
          <div class="card shadow mb-3">
            <div class="card-header bg-transparent">
              <h3 class="mb-0">
                Startups no batch
                <span v-if="batch">
                  <span class="text-warning">{{ batch.name }}</span>
                  <router-link :to="`/admin/batches/${batch.id}/editar`">
                    <i class="ml-2 fas fa-eye text-sm"></i>
                  </router-link>
                </span>
              </h3>
            </div>
            <div class="card-body vld-parent" ref="list_startups_batch">
              <div
                v-if="!batch.startups || !batch.startups.length"
                class="mt--2 text-center text-warning mt-3"
              >
                Não há startups no batch
              </div>
              <div class="row">
                <div
                  class="col-lg-3 col-md-4 mt-3 mb-4 d-flex align-items-stretch"
                  v-for="bs in batch.startups"
                  :key="'startup_' + bs.startup.user_id"
                >
                  <div class="card text-center flex-grow-1">
                    <div class="card-profile-image">
                      <img
                        :src="getStartupLogoPath(bs.startup.logo)"
                        class="card-image my-2"
                        alt="..."
                      />
                    </div>
                    <div class="card-body mt-7 pt-0 pb-1">
                      <h2 class="card-title text-orange mb-1">
                        {{ bs.startup.name }}
                      </h2>
                      <div class="h5 font-weight-300">
                        <i class="ni ni-pin-3 mr-2"></i
                        >{{ bs.startup.city || "..." }},
                        {{ bs.startup.state || "..." }}
                      </div>
                    </div>
                    <div class="card-footer text-center pt-3">
                      <base-button
                        type="white"
                        class="text-purple mt-2"
                        :iconOnly="true"
                        icon="fa fa-file-video"
                        title="Ver apresentação da startup"
                        @click="
                          handleViewStartupPresentation(bs.startup.user_id)
                        "
                      ></base-button>
                      <base-button
                        @click="handleViewStartupTasks(bs.startup.user_id)"
                        type="white"
                        icon="fas fa-clipboard"
                        :iconOnly="true"
                        class="text-primary mt-2"
                        title="Ver respostas"
                      ></base-button>
                      <base-button
                        type="white"
                        class="text-default mt-2"
                        :iconOnly="true"
                        icon="fa fa-align-left"
                        title="Ver relatórios qualitativos da startup"
                        @click="handleViewStartupReports(bs.startup.user_id)"
                      ></base-button>
                      <base-button
                        @click="handleViewStartupCards(bs.startup.user_id)"
                        type="white"
                        icon="fas fa-highlighter"
                        class="text-success mt-2"
                        :iconOnly="true"
                        title="Cards personalizados"
                      ></base-button>
                      <base-button
                        @click="handleViewStartupMetrics(bs.startup.user_id)"
                        type="white"
                        icon="fas fa-tachometer-alt"
                        class="text-warning mt-2"
                        :iconOnly="true"
                        title="Métricas de desempenho"
                      ></base-button>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row" v-if="batch && batch.startups.length">
                <div class="col-12">
                  <p v-if="batch" class="text-muted text-right mt-1 mb-0">
                    {{ batch.startups.length }} startups cadastradas no batch
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <div class="card shadow">
            <div class="card-header bg-transparent">
              <h3 class="mb-0">
                Tarefas
                <base-button
                  size="sm"
                  type="primary"
                  class="float-right"
                  :custom="true"
                  @click="handleNewTask()"
                  ><i class="fas fa-plus mr-1"></i> Nova tarefa
                </base-button>
                <base-button
                  size="sm"
                  type="default"
                  class="float-right mr-2"
                  :custom="true"
                  @click="handleOpenModalBaseTasks()"
                  ><i class="fas fa-clock mr-1"></i> Cronograma base
                </base-button>
              </h3>
            </div>
            <div class="card-body pb-2">
              <div class="vld-parent" ref="list_open_tasks">
                <task-list
                  :data="openTasks"
                  icon="fas fa-eye"
                  title="Ativas"
                  emptyMessage="Não há tarefas ativas no momento"
                />
                <div class="col-12 pr-0 text-right">
                  <base-button
                    type="link"
                    :custom="true"
                    v-if="openTasks.length === initialLimit"
                    @click="getOpenTasks()"
                    >Carregar todas tarefas ativas</base-button
                  >
                </div>
              </div>
              <hr class="mt-2 mb-4" />
              <div class="vld-parent" ref="list_future_tasks">
                <task-list
                  :data="futureTasks"
                  icon="fas fa-calendar-plus "
                  title="Futuras"
                  emptyMessage="Não há tarefas futuras"
                  :showDeadline="false"
                />
                <div class="col-12 pr-0 text-right">
                  <base-button
                    type="link"
                    :custom="true"
                    v-if="futureTasks.length === initialLimit"
                    @click="getFutureTasks()"
                    >Carregar todas tarefas futuras</base-button
                  >
                </div>
              </div>
              <hr class="mt-2 mb-4" />
              <div class="vld-parent" ref="list_past_tasks">
                <task-list
                  :data="pastTasks"
                  icon="fas fa-clipboard-list"
                  title="Histórico"
                  emptyMessage="Não há tarefas no histórico"
                />
                <div class="col-12 pr-0 text-right">
                  <base-button
                    type="link"
                    :custom="true"
                    v-if="pastTasks.length === initialLimit"
                    @click="getPastTasks()"
                    >Carregar todas tarefas do histórico</base-button
                  >
                </div>
              </div>
              <hr class="mt-2 mb-4" />
              <div class="vld-parent" ref="list_hidden_tasks">
                <task-list
                  :data="hiddenTasks"
                  icon="fas fa-eye-slash"
                  title="Invisíveis"
                  emptyMessage="Não há tarefas ocultas"
                />
                <div
                  class="col-12 pr-0 text-right"
                  v-if="hiddenTasks.length === initialLimit"
                >
                  <base-button
                    type="link"
                    :custom="true"
                    @click="getHiddenTasks()"
                    >Carregar todas tarefas ocultas</base-button
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <modal
      :show.sync="modalBaseTasks.show"
      modal-classes="modal-dialog-centered modal-lg"
      header-classes="pb-0"
      body-classes="pb-0"
    >
      <h6 slot="header" class="modal-title" id="modal-title-notification">
        Atenção!
      </h6>
      <div class="vld-parent" ref="modal_base_tasks">
        <div class="pb-2 text-center">
          <i class="fas fa-clock fa-3x"></i>
          <h4 class="heading mt-4">Cronograma base</h4>
        </div>
        <div class="row pt-3">
          <div class="col-lg-6">
            <label class="form-control-label"> Data inicial </label>
            <div>
              <base-input
                addon-left-icon="fas fa-calendar"
                type="date"
                v-model="modalBaseTasks.model.startDate"
              >
              </base-input>
            </div>
          </div>
          <div class="col-lg-6">
            <label class="form-control-label">
              Adicionar tarefas mês inicial
              <i
                class="fas fa-info-circle"
                title="Se selecionado irá adicionar as tarefas não recorrentes (visíveis apenas no primeiro mês), e.g. 'Saldo atual', 'Total de leads' e 'Total de clientes'."
              ></i>
            </label>
            <div>
              <base-switch
                v-bind:value="modalBaseTasks.model.initialTasks"
                @input="initialTasksChangedHandler($event)"
              />
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-6">
            <base-input
              type="number"
              label="Número de meses"
              v-model="modalBaseTasks.model.recurrenceMonths"
              :min="1"
            >
            </base-input>
          </div>
          <div class="col-lg-6">
            <base-input
              type="number"
              label="Prazo de submissão (dias)"
              v-model="modalBaseTasks.model.deadlineDays"
              :min="1"
            >
            </base-input>
          </div>
        </div>
        <div class="row" v-if="modalBaseTasks.model.startDate">
          <div class="col-12 text-center">
            <p class="text-sm">
              <i class="fas fa-info-circle mr-1"></i>
              As tarefas base a serem adicionadas ao batch iniciarão em
              <b class="font-weight-bold">{{
                moment(modalBaseTasks.model.startDate, "YYYY-MM-DD")
                  .locale("pt-br")
                  .format("MMMM [de] YYYY")
              }}</b
              >. O acompanhamento terá duração de
              <b class="font-weight-bold"
                >{{ modalBaseTasks.model.recurrenceMonths }} meses</b
              >
              (até
              <b class="font-weight-bold">
                {{
                  moment(modalBaseTasks.model.startDate, "YYYY-MM-DD")
                    .add(modalBaseTasks.model.recurrenceMonths, "M")
                    .locale("pt-br")
                    .format("MMMM [de] YYYY")
                }}</b
              >). Cada tarefa começará a aceitar respostas no
              <b class="font-weight-bold"
                >{{ formatDate(modalBaseTasks.model.startDate, "DD") }}º dia</b
              >
              de cada mês, com um prazo de submissão de
              <b class="font-weight-bold"
                >{{ modalBaseTasks.model.deadlineDays }} dias</b
              >
              a partir de sua data de abertura (o encerramento da tarefa será
              feito automaticamente).
            </p>
          </div>
        </div>
        <base-alert
          type="danger"
          class="text-center"
          v-if="modalBaseTasks.error"
        >
          {{ modalBaseTasks.error }}
        </base-alert>
      </div>
      <template slot="footer">
        <base-button
          type="link"
          text-color="dark"
          class="ml-auto"
          @click="modalBaseTasks.show = false"
        >
          Voltar
        </base-button>
        <base-button
          type="default"
          :disabled="!modalBaseTasks.model.startDate"
          @click="handleAddBaseTasks"
        >
          Adicionar tarefas
        </base-button>
      </template>
    </modal>
  </div>
</template>
<script>
import api from "@/services/api";

import TaskList from "@/components/TaskList";

export default {
  name: "adm_startup_tasks",
  components: {
    TaskList,
  },
  data() {
    return {
      stats: {
        totalTasks: 0,
        totalAvailableTasks: 0,
        totalResponses: 0,
        percentAnsweredTasks: "",
      },
      openTasks: [],
      futureTasks: [],
      pastTasks: [],
      hiddenTasks: [],
      initialLimit: 8,
      batch: "",
      startupsBatch: [],
      clicked: false,
      tasksLoaded: false,
      modalBaseTasks: {
        show: false,
        error: "",
        model: {
          startDate: "",
          recurrenceMonths: 12,
          deadlineDays: 10,
          initialTasks: false,
        },
      },
    };
  },
  async mounted() {
    await this.loadBatch();
    await this.getTasks();
    this.tasksLoaded = true;
    await this.calcStats();
  },
  methods: {
    async loadBatch() {
      const loaderBatch = this.$loading.show({
        container: this.$refs.list_startups_batch,
        width: 90,
        height: 90,
      });
      try {
        const { data: batch } = await api.get(
          `/batches/${this.$route.params.id}?with_startups=true`
        );
        if (!batch) {
          this.$toasted.error("Batch não encontrado!");
          this.$router.push("/admin/batches");
          return;
        }
        this.batch = batch;
      } catch (e) {
        this.$toasted.error("Error ao carregar informações do batch");
        this.$router.push("/admin/batches");
      }
      loaderBatch.hide();
    },
    async getTasks() {
      this.getOpenTasks(`&limit=${this.initialLimit}`);
      this.getFutureTasks(`&limit=${this.initialLimit}`);
      this.getPastTasks(`&limit=${this.initialLimit}`);
      this.getHiddenTasks(`&limit=${this.initialLimit}`);
    },
    async getOpenTasks(params = "") {
      this.loadTasks(
        `filter=open${params}`,
        "openTasks",
        this.$refs.list_open_tasks,
        "as tarefas ativas"
      );
    },
    async getFutureTasks(params = "") {
      this.loadTasks(
        `filter=future${params}`,
        "futureTasks",
        this.$refs.list_future_tasks,
        "as tarefas futuras"
      );
    },
    async getPastTasks(params = "") {
      this.loadTasks(
        `filter=past${params}`,
        "pastTasks",
        this.$refs.list_past_tasks,
        "as tarefas do histórico"
      );
    },
    async getHiddenTasks(params = "") {
      this.loadTasks(
        `filter=hidden${params}`,
        "hiddenTasks",
        this.$refs.list_hidden_tasks,
        "as tarefas invisíveis"
      );
    },
    async loadTasks(getParams, targetObjName, loaderRef, errorMsg) {
      const loader = this.$loading.show({
        container: loaderRef,
        width: 90,
        height: 90,
      });
      try {
        const { data } = await api.get(
          `/batches/${this.$route.params.id}/tasks?${getParams}`
        );
        if (data.length) this[targetObjName] = data;
        loader.hide();
      } catch (e) {
        this.$toasted.error(`Ocorreu um erro ao recuperar ${errorMsg}`);
      }
    },
    handleNewTask() {
      this.$router.push(
        `/admin/batches/${this.$route.params.id}/acompanhamento/tarefas/novo`
      );
    },
    handleOpenModalBaseTasks() {
      this.modalBaseTasks.error = "";
      this.modalBaseTasks.model.startDate = "";
      this.modalBaseTasks.model.recurrenceMonths = 12;
      this.modalBaseTasks.model.deadlineDays = 10;
      this.modalBaseTasks.model.initialTasks = false;
      this.modalBaseTasks.show = true;
    },
    async handleAddBaseTasks() {
      this.modalBaseTasks.error = "";
      let loader = this.$loading.show({
        container: this.$refs.modal_base_tasks,
        width: 140,
        height: 140,
      });
      const data = this.modalBaseTasks.model;
      try {
        await api.post(
          `/batches/${this.$route.params.id}/add-base-tasks`,
          data
        );
        this.$toasted.show("Cronograma base do batch adicionado com sucesso");
        this.$router.push("/admin/batches");
      } catch (e) {
        this.modalBaseTasks.error =
          "Ocorreu um erro ao inserir o cronograma de tarefas base do batch.";
        this.$toasted.error("Ocorreu um erro ao salvar as informações");
      }
      loader.hide();
    },
    getStartupLogoPath(logo) {
      const defaultLogoPath = "/img/pages/default_logo.png";
      if (!logo) return defaultLogoPath;
      return logo.url;
    },
    handleViewStartupPresentation(startupId) {
      this.$router.push(
        `/admin/batches/${this.$route.params.id}/acompanhamento/startups/${startupId}/apresentacao`
      );
    },
    handleViewStartupTasks(startupId) {
      this.$router.push(
        `/admin/batches/${this.$route.params.id}/acompanhamento/startups/${startupId}/respostas`
      );
    },
    handleViewStartupReports(startupId) {
      this.$router.push(
        `/admin/batches/${this.$route.params.id}/acompanhamento/startups/${startupId}/relatorios`
      );
    },
    handleViewStartupMetrics(startupId) {
      this.$router.push(
        `/admin/batches/${this.$route.params.id}/acompanhamento/startups/${startupId}/metricas`
      );
    },
    handleViewStartupCards(startupId) {
      this.$router.push(
        `/admin/batches/${this.$route.params.id}/acompanhamento/startups/${startupId}/cards`
      );
    },
    initialTasksChangedHandler(event) {
      if (typeof event === "boolean")
        this.modalBaseTasks.model.initialTasks = event;
    },
    async calcStats() {
      try {
        const { data } = await api.get(
          `/batches/${this.$route.params.id}/tasks-stats`
        );
        this.stats.totalTasks = data.totalTasks;
        this.stats.totalResponses = data.totalResponses;
        this.stats.totalAvailableTasks = data.totalAvailableTasks;
        const expectedResponses =
          this.stats.totalAvailableTasks * this.batch.startups.length;
        if (expectedResponses > 0) {
          this.stats.percentAnsweredTasks = Math.round(
            (this.stats.totalResponses / expectedResponses) * 100,
            2
          );
        }
        this.stats.percentAnsweredTasks = this.stats.percentAnsweredTasks
          ? String(this.stats.percentAnsweredTasks) + "%"
          : "-";
      } catch (e) {
        this.$toasted.error("Error ao calcular as estatísticas");
      }
    },
  },
};
</script>
<style>
.card-profile-image img {
  width: 120px;
  height: 120px;
  border-radius: 10%;
}
</style>
